/**
 * @module M/control/CallejeroRestControl
 */
import CallejeroRestImplControl from '../../impl/ol/js/callejerorestcontrol';
import template from '../../templates/callejerorest';
import results from '../../templates/results';
import { getValue } from './i18n/language';

const WFS_URL = 'https://geospatial.ayto-fuenlabrada.es/geoserver/ggiscloud_root/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=ggiscloud_root%3Aparce&srsName=EPSG:3857&outputFormat=application%2Fjson&cql_filter=direccion=***1';
const BASE_URL = 'https://sede.ayto-fuenlabrada.es/territorio/rest/wsterritorio/getelmenentosterritoriobycadena/json/';
let typingTimer;
/**
 * @classdesc
 * This class creates an input for searching locations on a map.
 * It uses Instituto Geográfico Nacional services Geocoder and Nomenclator
 * to search user's input location and return coordinates on click.
 */
export default class CallejeroRestControl extends M.Control {
  /*
   * @constructor
   * @extends {M.Control}
   * @api
   */
  constructor(zoom) {
    if (M.utils.isUndefined(CallejeroRestImplControl)) {
      M.exception(getValue('exception.impl'));
    }

    const impl = new CallejeroRestImplControl();
    super(impl, 'CallejeroRest');
    /**
     * Zoom
     *
     * @private
     * @type {number}
     */
    this.zoom = zoom;

    this.candidates = [];
  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api
   */
  createView(map) {
    this.map = map;
    this.clickedElementLayer = new M.layer.GeoJSON({
      name: getValue('searchresult'),
      source: {},
    });

    this.clickedElementLayer.displayInLayerSwitcher = false;
    this.clickedElementLayer.setZIndex(99999999999999999);
    this.map.addLayers(this.clickedElementLayer);
    this.createGeometryStyles();
    return new Promise((success) => {
      const html = M.template.compileSync(template, {
        vars: {
          translations: {
            deleteresults: getValue('deleteresults'),
            direccion: getValue('direccion'),
          },
        },
      });

      this.html = html;
      this.resultsBox = html.querySelector('#m-callejerorest-results');
      this.searchInput = this.html.querySelector('#m-callejerorest-search-input');
      html.querySelector('#m-callejerorest-clear-button').addEventListener('click', this.clearResultsAndGeometry.bind(this));
      html.querySelector('#m-callejerorest-search-input').addEventListener('keyup', e => this.createTimeout(e));
      html.querySelector('#m-callejerorest-search-input').addEventListener('keydown', () => {
        clearTimeout(typingTimer);
      });

      html.querySelector('#m-callejerorest-search-input').addEventListener('keydown', () => {
        clearTimeout(typingTimer);
      });

      document.querySelector('.callejerorest-panel>.m-panel-btn').addEventListener('click', this.clearResults.bind(this));
      success(html);
    });
  }

  /**
   * This function clears input content, results box, popup and shown geometry.
   * @public
   * @function
   * @api
   */
  clearResultsAndGeometry() {
    this.clearResults();
    if (this.clickedElementLayer !== undefined) {
      this.clickedElementLayer.clear();
    }

    this.map.removePopup(this.popup, [this.lng, this.lat]);
  }

  /**
   * This function sets a timeout between keypress and search.
   * @public
   * @function
   * @param {e} event that triggers the method
   * @api
   */
  createTimeout(e) {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => this.searchInputValue(e), 500);
  }
  /**
   * This function gets activation button
   *
   * @public
   * @function
   * @param {HTML} html of control
   * @api
   */
  getActivationButton(html) {
    return html.querySelector('.m-callejerorest button');
  }
  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api
   */
  equals(control) {
    return control instanceof CallejeroRestControl;
  }
  /**
   * This function
   * 1.- Takes user's input
   * 2.- Searches for ocurrences on IGN sources
   * 3.- Returns results as items in a drop-down list (returns address)
   * 4.- Onclick on an item goes to its coordinates
   * @public
   * @function
   * @param {event} e - event that triggers this method
   * @api
   */
  searchInputValue(e, firstResult = false) {
    const value = e.target.value;
    this.searchValue = this.formatInput_(value);
    if (value.length <= 2) {
      this.resultsBox.innerHTML = '';
    } else {
      this.resultsBox.innerHTML = '';
      // Adds animation class during loading
      this.resultsBox.classList.add('g-cartografia-spinner');
      this.resultsBox.style.fontSize = '24px';
      this.candidates = [];
      const searchUrl = BASE_URL.concat(this.searchValue);
      M.proxy(false);
      M.remote.get(searchUrl).then((res) => {
        M.proxy(true);
        const allResults = JSON.parse(res.text).valores;
        allResults.forEach((elem) => {
          if (elem[7] !== '' && elem[8] !== '' && elem[7] !== 'null' && elem[8] !== 'null') {
            const coords = this.getImpl().reproject([parseFloat(elem[7]), parseFloat(elem[8])], 'EPSG:25830', 'EPSG:3857');
            this.candidates.push({ id: elem[0], name: elem[1], type: elem[3], ref: elem[6], lon: coords[0], lat: coords[1] });
          }
        });

        this.resultsBox.innerHTML = '';
        const compiledResult = M.template.compileSync(results, {
          vars: {
            places: this.candidates,
          },
        });

        const elementList = compiledResult.querySelectorAll('li');
        elementList.forEach((listElement) => {
          listElement.addEventListener('click', () => {
            this.goToLocation(listElement);
          });
        });

        if (firstResult === true && elementList.length > 0) {
          elementList.item(0).click();
        }
        // remove animation class and return to normal font size after loading
        this.resultsBox.classList.remove('g-cartografia-spinner');
        this.resultsBox.style.fontSize = '1em';
        this.resultsBox.appendChild(compiledResult);
        // Service doesn't find results
        if (this.candidates.length === 0) {
          this.resultsBox.classList.remove('g-cartografia-spinner');
          this.resultsBox.style.fontSize = '1em';
          const parragraph = document.createElement('p');
          const infoMsg = document.createTextNode(getValue('exception.results'));
          parragraph.appendChild(infoMsg);
          parragraph.classList.add('m-callejerorest-no-results');
          this.resultsBox.appendChild(parragraph);
          document.getElementById('m-callejerorest-results-list').style.display = 'none';
        } else {
          document.getElementById('m-callejerorest-results-list').style.display = 'block';
        }
      }).catch((err) => {
        M.proxy(true);
        console.error(err);
        this.resultsBox.classList.remove('g-cartografia-spinner');
        this.resultsBox.style.fontSize = '1em';
        const parragraph = document.createElement('p');
        const infoMsg = document.createTextNode(getValue('exception.results'));
        parragraph.appendChild(infoMsg);
        parragraph.classList.add('m-callejerorest-no-results');
        this.resultsBox.appendChild(parragraph);
      });
    }
  }

  formatInput_(text) {
    let res = text.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
    if (res.indexOf('CL DE') === 0) {
      res = res.replaceAll('CL DE', '').trim();
    } else if (res.indexOf('CL') === 0) {
      res = res.replaceAll('CL', '').trim();
    } else if (res.indexOf('CALLE DE') === 0) {
      res = res.replaceAll('CALLE DE', '').trim();
    } else if (res.indexOf('CALLE') === 0) {
      res = res.replaceAll('CALLE', '').trim();
    }

    return res;
  }

  /**
   * This function zooms in clicked location and draws geometry
   * @public
   * @function
   * @param {Object} listElement clicked result information
   * @api
   */
  goToLocation(listElement) {
    this.currentElement = listElement;
    const selectedObject = this.findClickedItem(listElement, this.candidates);
    document.getElementById('m-callejerorest-search-input').value = selectedObject.name;
    if (selectedObject !== undefined && selectedObject !== null && selectedObject.lon !== '') {
      this.drawResult(selectedObject);
      this.drawPolygonResult(selectedObject);
    }

    this.resultsBox.innerHTML = '';
  }

  drawPolygonResult(selectedObject) {
    /* eslint-disable no-useless-escape */
    const url = WFS_URL.split('***1').join(encodeURIComponent(`\'${selectedObject.name.trim()}\'`));
    M.remote.get(url).then((response) => {
      const featuresResponse = JSON.parse(response.text);
      if (featuresResponse.features.length > 0) {
        const f = featuresResponse.features[0];
        const feature = new M.Feature(f.id, f);
        this.clickedElementLayer.addFeatures(feature);
        feature.setStyle(this.polygon);
      }
    }).catch((err) => {
      console.error(err);
    });
  }

  drawResult(selectedObject) {
    this.clearResultsAndGeometry();
    const f = new M.Feature(`feature_${selectedObject.id}`, {
      type: 'Feature',
      id: `feature_${selectedObject.id}`,
      geometry: {
        type: 'Point',
        coordinates: [selectedObject.lon, selectedObject.lat],
      },
      properties: {
        name: selectedObject.name,
        type: selectedObject.type,
        ref: selectedObject.ref,
      },
    });

    setTimeout(() => {
      this.clickedElementLayer.addFeatures(f);
      f.setStyle(this.point);
      this.map.setCenter([selectedObject.lon, selectedObject.lat]);
      this.map.setZoom(this.zoom);
    }, 200);

    this.showSearchPopUp(selectedObject);
  }

  /**
   * This function returns clicked location object
   * @public
   * @function
   * @param { string } listElement <li>Location</li>
   * @param { Array < Object > } candidates possible locations
   * @api
   */
  findClickedItem(listElement, candidates) {
    return candidates.filter((element) => {
      return element.id === listElement.getAttribute('id');
    })[0];
  }

  /**
   * This function clears drawn geometry from map.
   * @public
   * @function
   * @api
   */
  clearResults() {
    this.searchInput.value = '';
    this.resultsBox.innerHTML = '';
    this.searchValue = '';
  }

  /**
   * This function creates some geometry styles.
   * @public
   * @function
   * @api
   */
  createGeometryStyles() {
    // Shows pin on drawn point
    this.point = new M.style.Point({
      radius: 5,
      icon: {
        src: M.utils.concatUrlPaths([M.config.THEME_URL, '/img/pinign.svg']),
      },
    });

    this.polygon = new M.style.Polygon({
      fill: {
        color: '#71a7d3',
        opacity: 0.6,
      },
      stroke: {
        color: '#71a7d3',
        width: 3,
      },
    });
  }
  /**
    * This
    function inserts a popUp with information about the searched location
      (and whether it 's an exact result or an approximation)
    * @param { string } fullAddress location address(street, portal, etc.)
    * @param { Array } coordinates latitude[0] and longitude[1] coordinates
    * @param { boolean } exactResult indicating
    if the given result is a perfect match
    */
  showSearchPopUp(selectedObject) {
    this.map.removePopup(this.popup);
    const popupContent = { content: '', title: '' };
    popupContent.content += `
      <div><b>${selectedObject.name}</b></div><br/>
      <div class='ignsearchlocator-popup'><b>${getValue('type')}:&nbsp;&nbsp;</b>${selectedObject.type}</div>
      <div class='ignsearchlocator-popup'><b>${getValue('ref')}:&nbsp;&nbsp;</b>${selectedObject.ref}</div>
    `;

    const popup = new M.Popup({ panMapIfOutOfView: false });
    popup.addTab(popupContent);
    this.map.addPopup(popup, [selectedObject.lon, selectedObject.lat]);
    this.popup = popup;
    this.popup.getImpl().setOffset([0, -15]);
    this.lat = selectedObject.lat;
    this.lng = selectedObject.lon;
  }

  formatInfo_(info) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(info, 'text/xml');
    let codProv;
    let codMun;
    let response = {
      pc1: '',
      pc2: '',
      codProv: '',
      codMun: '',
      error: ''
    }
    const rootElement = xmlDoc.getElementsByTagName('consulta_coordenadas')[0];
    const controlNode = rootElement.getElementsByTagName('control')[0];
    const errorCtlNode = controlNode.getElementsByTagName('cuerr')[0].childNodes[0].nodeValue;
    if (errorCtlNode === '1') {
      const errorNode = rootElement.getElementsByTagName('lerr')[0];
      const errorDesc = errorNode.getElementsByTagName('err')[0];
      const errorDescTxt = errorDesc.getElementsByTagName('des')[0].childNodes[0].nodeValue;
      response['error'] = errorDescTxt;
    } else {
      const coordenadasNode = rootElement.getElementsByTagName('coordenadas')[0];
      const coordNode = coordenadasNode.getElementsByTagName('coord')[0];
      const pcNode = coordNode.getElementsByTagName('pc')[0];
      const pc1Node = pcNode.getElementsByTagName('pc1')[0].childNodes[0].nodeValue;
      const pc2Node = coordNode.getElementsByTagName('pc2')[0].childNodes[0].nodeValue;

      // Obtenemos códigos de provincia y municipio
      codProv = pc1Node.substring(0, 2);
      codMun = pc1Node.substring(2, 5);


      response['pc1'] = pc1Node;
      response['pc2'] = pc2Node;
      response['codProv'] = codProv;
      response['codMun'] = codMun;
      response['error'] = '';
    }

    return response;
  }

}
